/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-26 14:39:00
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-11-30 02:01:53
 * @Description: file content
 */
import axios from "axios";

export default class MyAxios {
  constructor() {
    this.axios = axios.create();
    // Add a request interceptor
    this.axios.interceptors.request.use(function (config) {
      // Do something before request is sent
      // console.log("http interceptors");
      return config;
    }, function (error) {
      // Do something with request error
      return Promise.reject(error);
    });

    // Add a response interceptor
    this.axios.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    });
  }
}